export const INVITEPERSON_OPEN = 'INVITEPERSON_OPEN';
export const INVITEPERSON_CLOSE = 'INVITEPERSON_CLOSE';
export const INVITEPERSON_SUBMIT = 'INVITEPERSON_SUBMIT';
export const INVITEPERSON_SUCCESS = 'INVITEPERSON_SUCCESS';
export const INVITEPERSON_FAILURE = 'INVITEPERSON_FAILURE';

export const INVITEAGAIN_SUBMIT = 'INVITEAGAIN_SUBMIT';
export const INVITEAGAIN_SUCCESS = 'INVITEAGAIN_SUCCESS';
export const INVITEAGAIN_FAILURE = 'INVITEAGAIN_FAILURE';

export const INVITEPERSON_ASSIGN_USER_MODAL_OPEN = 'INVITEPERSON_ASSIGN_USER_MODAL_OPEN';
export const INVITEPERSON_ASSIGN_USER_MODAL_CLOSE = 'INVITEPERSON_ASSIGN_USER_MODAL_CLOSE';

export const closeAssignUserSiteModal = () => ({
  type: INVITEPERSON_ASSIGN_USER_MODAL_CLOSE
});

export const openAssignUserSiteModal = () => ({
  type: INVITEPERSON_ASSIGN_USER_MODAL_OPEN
});

export const closeInvitePersonModal = () => ({
  type: INVITEPERSON_CLOSE
});

export const openInvitePersonModal = () => ({
  type: INVITEPERSON_OPEN
});

export const invitePersonAgain = id => ({
  type: INVITEAGAIN_SUBMIT,
  id
});

const initialState = {
  showModal: false,
  isFetching: false,
  errorMessage: undefined,
  showAssignUserSiteModal: false,
  assignSiteUserId: null
};

const invitePersonReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVITEPERSON_OPEN:
      return {
        ...state,
        showModal: true
      };
    case INVITEPERSON_ASSIGN_USER_MODAL_OPEN:
      return {
        ...state,
        showAssignUserSiteModal: true,
        assignSiteUserId: action.assignSiteUserId, 
      };
    case INVITEPERSON_ASSIGN_USER_MODAL_CLOSE:
      return {
        ...state,
        showAssignUserSiteModal: false,
        assignSiteUserId: null
      };
    case INVITEPERSON_CLOSE:
      return initialState;

    case INVITEPERSON_SUBMIT:
      return {
        ...state,
        isFetching: true,
        errorMessage: undefined
      };
    case INVITEPERSON_SUCCESS:
      return initialState;

    case INVITEPERSON_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage:
          typeof action.payload?._error === 'string' ? action.payload?._error : undefined
      };
    default:
      return state;
  }
};

export default invitePersonReducer;
